angular.module('app').component('dashboard', {
    templateUrl: 'application/components/dashboard/dashboard.template.html',
    controller: DashboardComponentController

});

DashboardComponentController.$inject = ['$scope', '$rootScope', '$window', '$http', '$interval', '$timeout', '$translate', 'GoogleChartService', 'DashboardDataServiceLV'];

function DashboardComponentController($scope, $rootScope, $window, $http, $interval,$timeout,  $translate, ChartService, DataService) {

    var chartProvider = ChartService.chartProvider();
    var dataProvider = DataService.dataProvider();
    var self = this;
    $translate.use($rootScope.LangForInterface);
    self.tilesacross = 2;
    self.tileunits = [1, 2];
    self.title = 'Sample Dashboard';
    self.layoutView = [];
    self.intervalpromises = {};

    self.assetUrlImg = 'www/assets/img/';
    self.tablecolumns = function () {
        return $scope.tablecolumns;
    }

    self.tablerows = function () {
        return $scope.tablerows;
    }

    self.goto = function goto(tile, item) {
        DataService.goto(tile, item);
    }




    DataService.getTileLayout().then(function (response) {
        tiles = response;
        var tile;
        if (tiles != null) {
            for (var t = 0; t < tiles.length; t++) {
                tile = tiles[t];
                tile.haveData = true;
                tile.id = 'tile-' + (t + 1).toString();
            }
        }

        computeLayout();
        refreshDashboard();
    });

    self.template = function template(tile) {

        if (tile.haveData) {
            var src = "application/components/dashboard/dashboard.tile.type.html";
            src = src.replace("tile.type", "tile." + tile.type);

            if (tile.template !== undefined && tile.template != null && tile.template.trim().length > 0) {
                src = src.replace(".html", '.' + tile.template + ".html");
            }

            return src;
        }
        else
            return src;
    }
    function refreshDashboard() {

        for (row in self.layoutView) {
            for (column in self.layoutView[row]) {
                var tile = self.layoutView[row][column];
                if (tile.dataSource != 'inline') {

                    getData(tile, row, column);

                }
            }
        }

    }

    function getData(tile, row, column) {
        if (tile.type == 'slide')
            $scope.numberLoaded = false; // disable slick
        DataService.getData(tile).then(function (response) {

            self.layoutView[row][column].value = response;
            // convertdata(tile);
            validateTile(tile);
            timer(tile, row, column);
            if (tile.type == 'slide')
                $scope.numberLoaded = true; // enable slick
        }, function (error) {
            //something wrong, stop interval
            $interval.cancel(self.intervalpromises[tile.title]);
        });
    }

    function timer(tile, row, column) {
        //setup interval for refresh 
        if (self.intervalpromises[tile.title] == null) {
            if (tile.interval === undefined || tile.interval == null || tile.interval < 5000)
                tile.interval = 30000;
            var p = $interval(function () { getData(tile, row, column) }, tile.interval);
            self.intervalpromises[tile.title] = p;
        }
    }

    function computeLayout() {
        if (tiles == null) {
            return;
        }

        var numcols = self.tablecolumns();
        if (numcols < 1) numcols = 1;

        tilesacross = numcols;
        tileunits = [];
        for (var u = 0; u < numcols; u++) {
            tileunits.push(u);
        }

        var newlayout = [];
        var index = 0;
        var row = [];
        var tileid = 1;

        var tile = null;
        for (var i = 0; i < tiles.length; i++) {
            tile = tiles[i];
            if (index + tile.width > numcols) {
                newlayout.push(row);
                row = [];
                index = 0;
            }
            tile.id = tileid.toString();
            tileid = tileid + 1;
            row.push(tile);
            index = index + tile.width;
        }
        if (row.length > 0) {
            newlayout.push(row);
        }

        $scope.tablerows = newlayout.length;
        $scope.numberLoaded = true;
        $scope.$on('want-to-change', function (event, datas) {
            $scope.$broadcast('need-to-chage', datas);
        });

        $scope.$on('want-to-change-click', function (event, datas) {
            $scope.$broadcast('select-d3js', datas);
        });

        $scope.$on('dj3', function (event, datas) {
            $timeout(function () {
                $scope.$broadcast('need-to-chage', { index: datas });
            }, 200);
        });

        self.layoutView = newlayout;

        //        refreshDashboard();
    }

    function validateTile(tile) {
        if (tile.hasOwnProperty('value')) {
            tile.haveData = true;
        }
        else {
            tile.haveData = false;
        }

        if (!tile.haveData) {
            tile.classes = tile.sizeClass + ' tile-gray';
        }
    }




}

